import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/order-review')({
  staticData: { title: 'Order review' },
  component: Outlet,
})
